<template>
  <div>
    <Header/>
    <router-view/>
    <Bottom class="app-bottom"/>
  </div>
</template>

<script>
import Header from '@/components/Header'
import Bottom from "@/components/Bottom";

export default {
  components: {
    Header,
    Bottom
  }

}

</script>

<style lang="scss">
@import "style/common.css";
@import "assets/fonts/iconfont.css";
//@import "//at.alicdn.com/t/c/font_3596696_48f0u2mt7i.css";

.app-bottom {
  margin-top: 20px;
}

.center-content {
  padding: 0 10% 0 10%;
  width: 100%;
}

.line-span {
  display: inline-block;
  width: 40px;
  height: 5px;
  margin-top: 5px;
  background-color: $basic-color;
  border-radius: 2px;
}
</style>
